import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-sections',
  templateUrl: './sections.component.html',
  styleUrls: ['./sections.component.scss']
})
export class SectionsComponent implements OnInit {
  @Input() typeList = [];
  @Input() selectedTab : string;
  @Input() hideSubsection:boolean = false;

  userData =  {
    section: 'Add Sections'
  };
  sectionList = [
    {
      val: 'Add Sections'
    }
  ];

  constructor() { }

  ngOnInit() {
    if(!this.hideSubsection){
      this.sectionList.push( {
        val: 'Add Sub Sections'
       })
    }
  }

}
